module.exports = __webpack_public_path__ + "img/data-center03.1eb44f8f.png";